const STANDING_PASSENGER_CAPACITY = 8

const DEFAULT_CAPACITIES = {
  smarttransit_bus: { passengerLoad: 27 },
  smarttransit_minibus: { passengerLoad: 17 }
}

function pluralize (count, singular, plural) {
  return count === 1 ? singular : plural
}

function getPassengerLoadOverride (transportationProfile) {
  const vehicle = transportationProfile && transportationProfile.metadata
    ? transportationProfile.metadata.vehicle
    : null
  const passengerLoad = vehicle ? vehicle.passengerLoad : null

  if (!passengerLoad && passengerLoad !== 0) {
    return null
  }

  const load = Number(passengerLoad)
  if (!load || Number.isNaN(load) || load <= 0) {
    return null
  }

  return load
}

function formatTotalAvailableSpotsLabel (availableTotal) {
  return availableTotal + ' ' + pluralize(availableTotal, 'spot', 'spots')
}

function resolveLivePassengerCount ({ metadata, passengers } = {}) {
  const passengerCount = metadata ? metadata.passengerCount : null

  if (passengerCount) {
    const count = Number(passengerCount)
    if (!Number.isNaN(count)) {
      return count
    }
  }

  if (Array.isArray(passengers)) {
    return passengers.length
  }

  return passengerCount === 0 ? 0 : null
}

/**
 * Resolve approximate available spots for SmartTransit vehicle types.
 *
 * Capacity order:
 * 1. metadata.vehicle.passengerLoad override for smarttransit bus/minibus
 * 2. smarttransit_bus default passenger load: 27
 * 3. smarttransit_minibus default passenger load: 17
 * 4. shared standing capacity: 8
 * 5. unsupported for other vehicle types
 *
 * @param {{transportationProfile?: object, transportType?: string, passengerCount?: number|null}} params
 * @returns {null|{supported:false}|{supported:true, mode:'total', passengerLoad:number, standingCapacity:number, availableTotal:number, label:string}}
 */
function resolveAvailableSpots ({ transportationProfile, transportType, passengerCount } = {}) {
  if (passengerCount === null || passengerCount === undefined || passengerCount === '') {
    return null
  }

  const count = Number(passengerCount)
  if (Number.isNaN(count) || count < 0) {
    return null
  }

  const resolvedType = transportType ||
    (transportationProfile && transportationProfile.transportType) ||
    null
  const defaults = resolvedType ? DEFAULT_CAPACITIES[resolvedType] : null

  if (!defaults) {
    return { supported: false }
  }

  const overrideLoad = getPassengerLoadOverride(transportationProfile)
  const passengerLoad = overrideLoad || defaults.passengerLoad
  const standingCapacity = STANDING_PASSENGER_CAPACITY
  const availableTotal = Math.max(passengerLoad + standingCapacity - count, 0)

  return {
    supported: true,
    mode: 'total',
    passengerLoad,
    standingCapacity,
    availableTotal,
    label: formatTotalAvailableSpotsLabel(availableTotal)
  }
}

module.exports = {
  DEFAULT_CAPACITIES,
  STANDING_PASSENGER_CAPACITY,
  resolveLivePassengerCount,
  resolveAvailableSpots
}
